import { render, staticRenderFns } from "./vc-form-group.vue?vue&type=template&id=06ac4a8b&scoped=true&"
import script from "./vc-form-group.vue?vue&type=script&lang=js&"
export * from "./vc-form-group.vue?vue&type=script&lang=js&"
import style0 from "./vc-form-group.vue?vue&type=style&index=0&id=06ac4a8b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac4a8b",
  null
  
)

export default component.exports